import React, { useState, useEffect, useRef } from 'react';

const FadeInSection = ({
  children,
  className = '',
  animation = 'fade-in-up',
  threshold = 0.15,
  rootMargin = '0px',
  delay = 0,
  style = {}
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    // Wenn bereits sichtbar, keinen neuen Observer erstellen
    if (isVisible) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // WICHTIG: Sofort disconnecten um doppelte Triggers zu verhindern!
          observer.disconnect();

          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      { threshold, rootMargin }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [threshold, rootMargin, delay, animation]);

  return (
    <div
      ref={sectionRef}
      className={`${className} ${isVisible ? animation : ''}`}
      style={{
        opacity: isVisible ? undefined : 0,
        transform: isVisible ? undefined : 'translateY(10px)',
        transition: isVisible ? undefined : 'none',
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;